var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.931,
    height: 58.93,
    viewBox: "0 0 58.931 58.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_579",
    x: 0,
    y: 0,
    width: 58.931,
    height: 58.93,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7229",
    "data-name": "Group 7229",
    transform: "translate(12 10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -10)",
    filter: "url(#Ellipse_579)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_579-2",
    "data-name": "Ellipse 579",
    cx: 17.465,
    cy: 17.465,
    rx: 17.465,
    ry: 17.465,
    transform: "translate(12 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M110.188,285.279a8.516,8.516,0,0,1-2.467.677,4.3,4.3,0,0,0,1.888-2.38,8.6,8.6,0,0,1-2.729,1.042,4.3,4.3,0,0,0-7.434,2.942,4.393,4.393,0,0,0,.109.977,12.2,12.2,0,0,1-8.858-4.492,4.3,4.3,0,0,0,1.326,5.736,4.214,4.214,0,0,1-1.948-.54v.055a4.3,4.3,0,0,0,3.449,4.214,4.309,4.309,0,0,1-1.13.153,4.358,4.358,0,0,1-.808-.076,4.306,4.306,0,0,0,4.017,2.985,8.635,8.635,0,0,1-5.338,1.839,9.163,9.163,0,0,1-1.026-.06,12.223,12.223,0,0,0,18.819-10.3c0-.186,0-.371-.011-.557a8.761,8.761,0,0,0,2.145-2.227h0Zm0,0",
    transform: "translate(-81.703 -273.763)",
    fill: "#00aff0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterCircle);
export default __webpack_public_path__ + "static/media/twitter-circle.6998b764ab74f506c9f97f1a885dfc7c.svg";
export { ForwardRef as ReactComponent };